<div class="game-detail-raffle-wrapper">
  <div class="game-detail-raffle">
    <h3 class="mt-2" cvLocalizedText langSection="Games_Reward_Estimator" langKey="raffle_game_details">Game Details</h3>
    <div class="separator"></div>
    <p class="mt-2" cvLocalizedText langSection="Games_Reward_Estimator" langKey="information_raffle">This information will tell you more about Raffle Game</p>
    <h4 cvLocalizedText langSection="Games_Reward_Estimator" langKey="raffle_payout">Raffle Payout</h4>
    <div *ngFor="let reward of rewards; index as i">
      <span>{{ getRank(i) }} Prize</span>
      <div class="raffle-rewards">
        <p *ngIf="isCoin(reward)" class="raffle-reward">
          <img src="../App_Themes/Standard/Images/CoreTheme/Gamification/Games/CoinsIcon.svg" class="raffle-icon" />
          <span>{{ reward.Coins.rewardValue }}</span>
        </p>
        
        <p *ngIf="isXP(reward)" class="raffle-reward">
          <img src="../App_Themes/Standard/Images/CoreTheme/Gamification/Games/XPFire.svg" class="raffle-icon" />
          <span>{{ reward.XP.rewardValue }}</span>
        </p>
        
        <p *ngIf="isCustom(reward)" class="raffle-reward">
          <img src="../App_Themes/Standard/Images/CoreTheme/Gamification/Games/gift-icon.svg" class="raffle-icon" />
          <span>{{ reward.Custom.rewardText }}</span>
        </p>
      </div>
    </div>
  </div>
</div>